import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
export interface Introduction {
  id: number;
  field_introduction_text: string;
  field_introduction_text_ms: string;
  field_introduction_text_zhans: string;
  field_inrto_description: string;
  field_inrto_description_ms: string;
  field_inrto_description_zhans: string;
  intro_image: string;
  status: boolean;
}

interface TrainingFacilities {
  id: number;
  icon: string;
  field_heading: string;
  field_heading_ms: string;
  field_heading_zhans: string;
  nid: number;
  images: {
    image: string;
  }[];
  field_img: string[];
  published: boolean;
}

interface AccreditationAndCertifications {
  nid: number;
  id: number;
  field_certifications_title: string;
  field_certifications_title_ms: string;
  field_certifications_title_zhans: string;
  icons: { image: string }[];
  field_desc: string;
  field_desc_ms: string;
  field_desc_zhans: string;
  video_link_1: string;
  video_link_2: string;
  field_images: string[];
  published: boolean;
}
interface Milestones {
  id: number;
  image: string;
  img_desc: string;
  Hyperlink: {
    id: string;
    text: string;
    link: string;
  }[];
  published: boolean;
}

interface NewsCard {
  id: string;
  image: string;
  header: string;
  date: string;
  description: string;
}

interface News {
  field_latest_news_text: string;
  field_latest_news_text_ms: string;
  field_latest_news_text_zhans: string;
  nid: number;
  view: NewsCard[];
}

export interface LatestNewsList {
  id: number;
  field_img: string;
  field_header: string;
  field_header_ms: string;
  field_header_zhans: string;
  field_date: string;
  field_latest_news_date: string;
  field_description: string;
  field_description_ms: string;
  field_description_zhans: string;
  created_at: string;
  parent_id: number;
  published: boolean;
}
export interface OurClient {
  nid: number;
  field_our_client_text: string;
  field_our_client_text_ms: string;
  field_our_client_text_zhans: string;
  details: ClientDetail[];
}

export interface ClientDetail {
  id: number;
  area: string;
  Clients_list: Client[];
}

export interface Client {
  id: string;
  client: string;
}
export interface TrainingAcademyBanner {
  id: number;
  field_banner_image: string;
  field_image_link: string;
  created: string;
  status: boolean;
  parent_id: number;
  published: boolean;
  created_at: string;
  order_sequence: any;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await corporateCMSApi.get<T>(url);
  console.log("fetchData", response, url);
  return response.data;
};

export const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooksForPages =
  <T>(key: string, getUrl: (listId: string) => string) =>
  (
    listId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

const useIntroduction = createDataHook<Introduction[]>(
  "introduction",
  `/api/malaysia-airports-training-academy2/allfields`
);

const useTrainingFacilities = createDataHooksForPages<TrainingFacilities[]>(
  "trainingFacilities",
  (listId) => `/api/malaysia-airports-facilities-training/allfields`
);

const useAccreditationAndCertifications = createDataHook<AccreditationAndCertifications[]>(
  "accreditationAndCertifications",
  `/api/malaysia-airports-training-academy3/all-fields/achievements`
);

const useMilestones = createDataHooksForPages<Milestones[]>(
  "milestones",
  (id: any) => `/api/malaysia-airports-training-academy4/${id}`
);

const useNews = createDataHook<News[]>("trainingAcademyNews", `/api/malaysia-airports-training-academy6/allfields`);
const useLatestNewsList = createDataHooksForPages<LatestNewsList[]>(
  "latestNewsList",
  (id: any) => `/api/airport-academy/latest-news/all-fields/${id}`
);
const useOurClient = createDataHook<OurClient[]>("ourClient", `/api/malaysia-airports-training-academy5/allfields`);
const useTrainingAcademyBanner = createDataHooksForPages<TrainingAcademyBanner[]>(
  "trainingAcademyBanner",
  (id: any) => `/api/malaysia-airports-training-academy/all-fields/${id}`
);

export {
  useAccreditationAndCertifications,
  useIntroduction,
  useLatestNewsList,
  useMilestones,
  useNews,
  useOurClient,
  useTrainingAcademyBanner,
  useTrainingFacilities,
};
